export const BUSINESS_LINK = 'https://ressources.mihotel.fr/hotel-voyage-d-affaires-lyon';

export const MAX_PEOPLE_IN_SEARCH = 5
export const DEFAULT_PEOPLE_IN_SAERCH = 2;
export const CAN_BOOK_DAY_USE = false;
export const SWITCH_DAY_AFTER_HOUR = 22; // if we search after 22h then the default search is for the next day



// WEBPACK FOOTER //
// ./src/common.js